import axiosInstance from './axiosInstance';

// 📥 GSTR2B Upload
export const uploadGSTR2BExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/import-gstr2b-excel', formData);
};

// 📊 GSTR2B Summary
export const getGSTR2BSummary = () =>
  axiosInstance.get('/gstreco/main');

// 📄 GSTR2B Details
export const getGSTR2BDetails = (supplier) =>
  axiosInstance.get(`/gstreco/details/${encodeURIComponent(supplier)}`);

// 📥 GST RCM Upload
export const uploadRCMExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/import-gst-rcm', formData);
};

// 📊 RCM Summary
export const getRCMSummary = () =>
  axiosInstance.get('/gstreco/rcm/summary');

// 📄 RCM Details
export const getRCMDetails = (supplier) =>
  axiosInstance.get(`/gstreco/rcm/details/${encodeURIComponent(supplier)}`);


// 📊 Get Uploaded time
export const getUploadedTime = () =>
  axiosInstance.get('/get-Uploaded-Time');

// 📊 Patch For Complete
export const completeClick = () =>
  axiosInstance.patch('/update-gstr2b-complete');

// 📊 Get CompleteWithin time
export const getCompleteWithin = () =>
  axiosInstance.get('/get-CompleteWithin-Time');

// 📊 Get GSTReco_RCM_CompareResults
export const getCompareResults = () =>
  axiosInstance.get('/get-CompareResults');

// 📊 GSTR2B Summary Quarter/main
export const getGSTR2BSummaryQuarter = () =>
  axiosInstance.get('/gstreco-Quarter/main');

// 📄 GSTR2B Details
export const getGSTR2BDetailsQuarter = (supplier) =>
  axiosInstance.get(`/gstreco-Quarter/details/${encodeURIComponent(supplier)}`);

// 📊 Get TallyContra
export const getTallyContra = () =>
  axiosInstance.get('/tally/contra');

// 📊 Get TallyPayment
export const getTallyPayment = () =>
  axiosInstance.get('/tally/payment');

// 📊 Get TallyPurchase
export const getTallyPurchase = () =>
  axiosInstance.get('/tally/purchase');

// 📊 Get TallyReceipt
export const getTallyReceipt = () =>
  axiosInstance.get('/tally/receipt');

// 📊 Get TallySales
export const getTallySales = () =>
  axiosInstance.get('/tally/sales');

// 📊 Get All GST Data
export const getAllGSTR2B = () =>
  axiosInstance.get('/gstreco/All-Data');


// 📥 Tally Bank Import (HDFC / AXIS)
export const uploadTallyBankExcel = (file, bank) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('bank', bank); // 'HDFC' or 'AXIS'
  return axiosInstance.post('/import-tally', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getTallyData = (params) => {
  return axiosInstance.get("/tally-data", { params });
};


// ==========================================
// 📥 WAGES APIs
// ==========================================

export const getWagesSummary = (month) => axiosInstance.get(`/wages/summary?month=${month}`);
export const getMonthlyWages = (month) => axiosInstance.get(`/wages/monthly?month=${month}`);
export const getMonthlyWagesLotwise = (month) => axiosInstance.get(`/wages/monthly-lotwise?month=${month}`);

// ==========================================
// 📥 BANK-TALLY RECONCILIATION APIs
// ==========================================

export const uploadBankStatementReco = (file, month) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  return axiosInstance.post("/bank-tally/upload-bank", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadTallyDataReco = (file, month) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  return axiosInstance.post("/bank-tally/upload-tally", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const runBankTallyReconciliation = (month) =>
  axiosInstance.post(`/bank-tally/run-reconciliation`, { month });


// ==========================================
// ICICI BANK-TALLY RECONCILIATION APIs
// ==========================================
export const uploadICICIBankStatementReco = (file, month) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  return axiosInstance.post("/icici-bank-tally/upload-bank", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadICICITallyDataReco = (file, month) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  return axiosInstance.post("/icici-bank-tally/upload-tally", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const runICICIBankTallyReconciliation = (month) =>
  axiosInstance.post("/icici-bank-tally/run-reconciliation", { month });
// ==========================================
// 📥 AXIS BANK AUTOMATION APIs
// ==========================================

export const uploadAxisExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/axis-transactions/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getAxisDashboard = () => 
  axiosInstance.get('/axis-transactions/dashboard');

export const updateAxisVoucher = (transactionId, newVoucherNumber) => 
  axiosInstance.patch('/axis-transactions/update-voucher', { transactionId, newVoucherNumber });

// Note: Export returns an Excel file (blob)
export const exportAxisMatched = () => 
  axiosInstance.get('/axis-transactions/export', { responseType: 'blob' });

  // Refresh DB Matches (Sync with ExpenseEntries)
export const refreshAxisMatches = () => 
  axiosInstance.post('/axis-transactions/refresh');

export const clearAxisUnmatched = () => 
  axiosInstance.delete('/axis-transactions/clear-unmatched');

export const splitAxisVoucherMatch = (transactionId, splits) => 
  axiosInstance.post('/axis-transactions/split-match', { transactionId, splits });

// Get Data for Excel Export
export const getExportData = (month) =>
  axiosInstance.get('/gstreco/export-data', { params: { month } });